import { Button } from '@/components/ui/button';

interface QueueDecisionButtonsProps {
  acceptLabel: string;
  isAcceptDisabled: boolean;
  isBusy: boolean;
  acceptHint: string | undefined;
  reason: string | undefined;
  onAccept: () => void;
  onReject: () => void;
}

export function QueueDecisionButtons({
  acceptLabel,
  isAcceptDisabled,
  isBusy,
  acceptHint,
  reason,
  onAccept,
  onReject,
}: QueueDecisionButtonsProps) {
  return (
    <div className="flex w-min flex-col gap-1.5">
      <div className="flex gap-1.5">
        <Button
          type="button"
          size="sm"
          disabled={isAcceptDisabled}
          title={acceptHint}
          onClick={onAccept}
        >
          {acceptLabel}
        </Button>
        <Button type="button" size="sm" variant="outline" disabled={isBusy} onClick={onReject}>
          Reject
        </Button>
      </div>
      {reason ? (
        <span className="text-2xs leading-tight whitespace-normal text-muted-foreground">
          {reason}
        </span>
      ) : null}
    </div>
  );
}
